import { render, staticRenderFns } from "./ProjectsFilter.vue?vue&type=template&id=3132483b&scoped=true"
import script from "./projectsFilter.ts?vue&type=script&lang=ts&external"
export * from "./projectsFilter.ts?vue&type=script&lang=ts&external"
import style0 from "./ProjectsFilter.vue?vue&type=style&index=0&id=3132483b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3132483b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3132483b')) {
      api.createRecord('3132483b', component.options)
    } else {
      api.reload('3132483b', component.options)
    }
    module.hot.accept("./ProjectsFilter.vue?vue&type=template&id=3132483b&scoped=true", function () {
      api.rerender('3132483b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/sections/manager/projects/projects-filter/ProjectsFilter.vue"
export default component.exports